export const LIGHTNING_PICK_RADIUS_CSS_PX = 8;
export const LIGHTNING_PICK_SIZE_CSS_PX = LIGHTNING_PICK_RADIUS_CSS_PX * 2;
export const LIGHTNING_PICK_MAX_ROWS = 100;
export const LIGHTNING_PICK_MAX_PASSES = 8;

export type LightningBinaryPickHit = Readonly<{
  pointIndex: number;
  distanceSquaredCssPx: number;
}>;

export type LightningBinaryPickResult = Readonly<{
  hits: readonly LightningBinaryPickHit[];
  truncated: boolean;
}>;

export function decodeLightningPickId(bytes: Uint8Array, offset: number): number {
  return bytes[offset] + bytes[offset + 1] * 0x100 + bytes[offset + 2] * 0x1_0000 + bytes[offset + 3] * 0x100_0000;
}

export function collectLightningPickPass(
  bytes: Uint8Array,
  width: number,
  height: number,
  devicePixelRatio: number,
  hits: Map<number, number>,
): boolean {
  let found = false;
  const centerX = width / 2;
  const centerY = height / 2;
  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      const encodedId = decodeLightningPickId(bytes, (y * width + x) * 4);
      if (encodedId === 0) {
        continue;
      }
      found = true;
      const pointIndex = encodedId - 1;
      const distanceX = (x + 0.5 - centerX) / devicePixelRatio;
      const distanceY = (y + 0.5 - centerY) / devicePixelRatio;
      const distanceSquared = distanceX * distanceX + distanceY * distanceY;
      const previousDistance = hits.get(pointIndex);
      if (previousDistance === undefined || distanceSquared < previousDistance) {
        hits.set(pointIndex, distanceSquared);
      }
    }
  }
  return found;
}

export function finalizeLightningPickHits(hits: ReadonlyMap<number, number>): LightningBinaryPickResult {
  const sorted = Array.from(hits, ([pointIndex, distanceSquaredCssPx]) => ({
    pointIndex,
    distanceSquaredCssPx,
  })).sort(
    (left, right) => left.distanceSquaredCssPx - right.distanceSquaredCssPx || left.pointIndex - right.pointIndex,
  );
  return {
    hits: sorted.slice(0, LIGHTNING_PICK_MAX_ROWS),
    truncated: sorted.length > LIGHTNING_PICK_MAX_ROWS,
  };
}
